import { Link, NavLink } from "react-router-dom";
import { LayoutDashboard, Inbox, Users, Receipt, Package, KeyRound, Settings, LogOut, ExternalLink, Radar } from "lucide-react";
import { Logo } from "@/components/Logo";

export const SECTIONS = [
  ["dashboard", "Dashboard", LayoutDashboard],
  ["contatti", "Contatti · Primo passo", Inbox],
  ["clienti", "Clienti percorso", Users],
  ["checkup", "Check-up · Consulenze", Radar],
  ["ordini", "Ordini e incassi", Receipt],
  ["prodotti", "Prodotti", Package],
  ["accessi", "Accessi app NUTRI", KeyRound],
  ["impostazioni", "Impostazioni sito", Settings],
];

const linkCls = ({ isActive }) =>
  `flex shrink-0 items-center gap-3 px-4 py-3 font-mono text-xs uppercase tracking-widest transition-colors ${isActive ? "bg-[#98bfa2] text-[#050807]" : "text-[#a3b1aa] hover:bg-white/5 hover:text-[#f4f7f5]"}`;

const Nav = ({ current }) => (
  <nav className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible" data-testid="admin-nav">
    {SECTIONS.map(([key, label, Icon]) => (
      <NavLink key={key} to={`/admin/${key}`} data-testid={`admin-nav-${key}`} className={() => linkCls({ isActive: current === key })}>
        <Icon size={15} /> <span className="whitespace-nowrap">{label}</span>
      </NavLink>
    ))}
  </nav>
);

export const AdminShell = ({ current, title, onLogout, children }) => (
  <div data-testid="admin-dashboard" className="min-h-screen lg:grid lg:grid-cols-[270px_1fr]">
    <aside className="border-b border-[rgba(152,191,162,0.15)] bg-[#070b09] lg:sticky lg:top-0 lg:flex lg:h-screen lg:flex-col lg:border-b-0 lg:border-r">
      <div className="flex items-center justify-between px-5 py-5">
        <Link to="/" data-testid="admin-home-link"><Logo testid="admin-logo" /></Link>
        <button data-testid="admin-logout-btn-mobile" onClick={onLogout} className="p-2 text-[#a3b1aa] hover:text-[#c4dcca] lg:hidden" aria-label="Esci"><LogOut size={16} /></button>
      </div>
      <p className="hidden px-5 pb-3 font-mono text-[11px] uppercase tracking-widest text-[#98bfa2] lg:block">Back office</p>
      <div className="px-3 pb-3 lg:pb-0"><Nav current={current} /></div>
      <div className="mt-auto hidden space-y-1 px-3 pt-6 lg:block">
        <a href="/" target="_blank" rel="noreferrer" data-testid="admin-view-site" className="flex items-center gap-3 px-4 py-3 font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]"><ExternalLink size={15} /> Vedi il sito</a>
        <button data-testid="admin-logout-btn" onClick={onLogout} className="flex w-full items-center gap-3 px-4 py-3 font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]"><LogOut size={15} /> Esci</button>
      </div>
    </aside>
    <main className="min-w-0 px-5 py-8 md:px-10 md:py-10">
      <h1 data-testid="admin-section-title" className="mb-8 font-display text-4xl font-900 uppercase md:text-5xl">{title}</h1>
      {children}
    </main>
  </div>
);
